<script lang="ts" setup>

  const { t } = useI18n()
</script>

<template>
  <div class="c-app-link-block">
    <ActionBlock :title="t('common.download-the-app')">
      <template #title-icon>
        <SvgIcon
          class="app-logo"
          icon="bookandgolf"
          :width="60"
          :height="60"
        />
      </template>
      <template #default>
        <AppLinks />
      </template>
    </ActionBlock>
  </div>
</template>

<style scoped>
.c-app-link-block {
  .c-action-block {
    .app-logo {
      border-radius: 10px;
      margin-right: 1.5em;
      background-color: white;
      box-shadow: var(--box-shadow-1);
    }

    .header {
      .title {
        text-align: left;
      }
    }

    .c-app-links {
      max-width: 30em;
      margin-top: 1em;
    }
  }

  @media screen and (width >= 1024px) {
    .c-action-block {
      .app-logo {
        margin: 2em 4em 1em 1em;
        transform: scale(2);
      }

      .c-app-links {
        margin-top: 0;
      }
    }
  }
}
</style>
